<template>
  <div class="object-types-list">
    <el-checkbox-group
      :value="localValue"
      @input="val => (localValue = val)"
      :disabled="field.isDisabled"
      :size="field.componentProps ? field.componentProps.size : 'mini'"
    >
      <el-checkbox
        v-for="option in filteredOptions"
        :key="option.value"
        :label="option.value"
        class="object-type-option"
      >
        {{ option.label }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'GenericFieldObjectTypesCheckbox',
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    searchValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    localValue: {
      get() { 
        // S'assurer de toujours retourner un tableau, jamais null
        return this.value || []
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', { field: this.field.name, value: val })
      }
    },
    
    // Niveau à afficher (extrait des properties)
    targetLevel() {
      if (!this.field.properties) return 3 // Par défaut niveau 3
      return this.field.properties.level || 3
    },
    
    // Options des types d'objets filtrés par niveau
    options() {
      if (!this.field || !this.field.dataSource) {
        return []
      }
      
      // Si la source est de type 'service', récupérer depuis le contexte
      if (this.field.dataSource.type === 'service') {
        const serviceData = this.getServiceData()
        return this.extractLevelOptions(serviceData)
      }
      
      // Sinon, utiliser les données statiques (venant de /config)
      if (this.field.dataSource.data && Array.isArray(this.field.dataSource.data)) {
        return this.extractLevelOptions(this.field.dataSource.data)
      }
      
      return []
    },
    
    filteredOptions() {
      if (!this.searchValue || this.searchValue.trim() === '') {
        return this.options
      }
      
      const search = this.searchValue.toLowerCase()
      return this.options.filter(option => 
        option.label.toLowerCase().includes(search)
      )
    }
  },
  
  methods: {
    // Récupérer les données du service (depuis le contexte ou le store)
    getServiceData() {
      // Les données objectTypes sont stockées dans le contexte du formulaire
      // et sont injectées par le parent ApiSearchForm
      if (this.field.dataSource && this.field.dataSource.data && Array.isArray(this.field.dataSource.data)) {
        return this.field.dataSource.data
      }
      
      // Fallback: essayer de récupérer depuis le store
      const storeGetter = 'getObjectTypes'
      if (this.$store.getters[storeGetter]) {
        return this.$store.getters[storeGetter]
      }
      
      return []
    },
    
    // Extraire uniquement les options du niveau ciblé
    extractLevelOptions(data) {
      if (!Array.isArray(data)) {
        return []
      }
      
      const level = this.targetLevel
      
      // Filtrer les éléments qui correspondent exactement au niveau demandé
      // La structure est: { code, libelle, niveau, parent, ... }
      const filtered = data.filter(item => {
        const itemLevel = item.niveau || item.level || 0
        return itemLevel === level
      })
      
      // Formatter les données pour les checkboxes
      return filtered.map(item => ({
        value: String(item.code || item.value || item.id),
        label: item.libelle || item.label || item.name || `Type ${item.code}`
      }))
    }
  }
}
</script>

<style scoped>
.object-types-list {
  width: 100%;
}

.object-type-option {
  display: block !important;
  margin: 0 0 6px 0 !important;
}
</style>

